import React from 'react';
import environment from '../config/environment';

const COMPANY_NAME = environment.companyName || 'Moreseg Cia. Ltda.';

// Componente para logo cuadrado (usado en login)
export const SquareLogo = ({ className = "w-12 h-12", color = "text-gray-700" }) => {
  return (
    <svg className={`${className} ${color}`} fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
  );
};

// Componente para logo horizontal (usado en header)
export const HorizontalLogo = ({ showText = true, className = "w-6 h-6", color = "text-white" }) => {
  return (
    <div className="flex items-center space-x-3">
      <div className={`w-10 h-10 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center shadow-sm`}>
        <svg className={`${className} ${color}`} fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      </div>
      {showText && (
        <div className="hidden sm:block">
          <h1 className="text-xl font-bold text-gray-900">
            {COMPANY_NAME}
          </h1>
          <p className="text-sm text-gray-600">
            Bitácora Electrónica
          </p>
        </div>
      )}
    </div>
  );
};

// Componente para logo con imagen personalizada
export const CustomLogo = ({ 
  src, 
  alt = "Logo", 
  size = "w-12 h-12", 
  className = "",
  showText = true,
  title = COMPANY_NAME,
  subtitle = "Bitácora Electrónica"
}) => {
  return (
    <div className="flex items-center space-x-3">
      <img 
        src={src} 
        alt={alt} 
        className={`${size} object-contain ${className}`}
      />
      {showText && (
        <div className="hidden sm:block">
          <h1 className="text-xl font-bold text-gray-900">
            {title}
          </h1>
          <p className="text-sm text-gray-600">
            {subtitle}
          </p>
        </div>
      )}
    </div>
  );
};

// Componente para logo cuadrado con imagen personalizada
export const CustomSquareLogo = ({ 
  src, 
  alt = "Logo", 
  size = "w-24 h-24", 
  className = "",
  containerClassName = "bg-white rounded-2xl shadow-lg"
}) => {
  return (
    <div className={`mx-auto ${size} ${containerClassName} flex items-center justify-center`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-3/4 h-3/4 object-contain ${className}`}
      />
    </div>
  );
};

export default {
  SquareLogo,
  HorizontalLogo,
  CustomLogo,
  CustomSquareLogo
}; 